import { Component, Injector, inject as inject_1 } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MaterialModule, JkBaseOption, JkDialogEditComponent, jkRestReturn } from 'jk-service';
import { StkmjService, templateUrlConfigStk } from './../_service_stk';
import { Stkmj } from '../_entity_stk';
import { JackBaseComponentModule } from 'jk-service';
import { AdvComModule } from 'jk-advcom';


@Component({
  selector: 'app-stkmj-edit',
  templateUrl: './stkmj-editPkg.component.html',//templateUrlConfigStk.stkmj,
  styleUrls: [],
  standalone: true,
  imports: [JackBaseComponentModule, MaterialModule, AdvComModule],
})

export class StkmjEditComponent extends JkDialogEditComponent<StkmjService, Stkmj> {
  override dialogRef: MatDialogRef<StkmjEditComponent>;
  override data: jkRestReturn;

  override srv!: StkmjService;
  constructor() {
    const inject = inject_1(Injector);
    const dialogRef = inject_1<MatDialogRef<StkmjEditComponent>>(MatDialogRef);
    const data = inject_1<jkRestReturn>(MAT_DIALOG_DATA);

    super(inject, dialogRef, data);
  
    this.dialogRef = dialogRef;
    this.data = data;
  }


}
